export function isPortal() {
    const values = ['true', 'True', 1, '1'];
    return values.includes(process.env.REACT_APP_PORTAL);
};



// WEBPACK FOOTER //
// ./src/modules/utils.js